import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'The type of training or learning support a stakeholder is likely to need',
    name: 'Stakeholder Training Audience',
    partialId: PartialId.Standard.create('stakeholder_training_audience'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
